import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Indicateur global de récupération des listes documents (style barre de progression).
 * Compteur pour gérer plusieurs requêtes parallèles (ex. onglet « Tous »).
 */
@Injectable({ providedIn: 'root' })
export class DocumentListLoadingService {
    private pending = 0;
    private readonly _loading$ = new BehaviorSubject<boolean>(false);

    readonly loading$ = this._loading$.asObservable();

    get isLoading(): boolean {
        return this._loading$.getValue();
    }

    start(): void {
        this.pending += 1;
        if (!this._loading$.getValue()) {
            this._loading$.next(true);
        }
    }

    stop(): void {
        this.pending = Math.max(0, this.pending - 1);
        if (this.pending === 0) {
            this._loading$.next(false);
        }
    }

    reset(): void {
        this.pending = 0;
        this._loading$.next(false);
    }
}
